module.exports = __webpack_public_path__ + "static/media/logo-oversinerco.6e8f4a88.svg";